import type { Locale } from 'date-fns';

const getLocalesDate = async (languageCode?: string): Promise<Locale> => {
  switch (languageCode ?? '') {
    case 'en':
      return (await import('date-fns/locale/en-US')).enUS;
    case 'ru':
      return (await import('date-fns/locale/ru')).ru;
    case 'uk':
      return (await import('shared/date-fns')).ukCustom;
    case 'de':
      return (await import('date-fns/locale/de')).de;
    case 'fr':
      return (await import('date-fns/locale/fr')).fr;
    default:
      return (await import('date-fns/locale/en-US')).enUS;
  }
};

export { getLocalesDate };
